import { callAI, safeJSON } from "./aiClient";
import { useState, useRef, useCallback, useEffect } from "react";
import * as mammoth from "mammoth";

/* HISTORY SYSTEM - auto save last 5 resumes */
const HISTORY_SK = "resume_history_v1";
function loadHistory(){try{return JSON.parse(localStorage.getItem(HISTORY_SK)||"[]");}catch{return[];}}
function saveToHistory(resume){
  try{
    const h=loadHistory();
    const entry={id:Date.now(),name:resume.name||"未知",title:resume.title||"",ts:new Date().toLocaleDateString("zh-CN"),resume};
    const filtered=h.filter(x=>x.name!==entry.name||x.title!==entry.title);
    const updated=[entry,...filtered].slice(0,5);
    localStorage.setItem(HISTORY_SK,JSON.stringify(updated));
    return updated;
  }catch{return[];}
}

/* LOCK SYSTEM - edit price, contact, and hashes here */
const RESUME_SINGLE_PRICE = "9.9";
const RESUME_BUNDLE_PRICE = "19.9";
const RESUME_CONTACT      = "X79Y99";
const RESUME_SK           = "resume_v2";

// QR code image URLs - paste your payment QR code image links here
// Use same link for both if you have one QR code for all payments
const QRCODE_SINGLE = "https://www.aixuexi.store/zhifu.jpg"; // single tool payment QR
const QRCODE_BUNDLE = "https://www.aixuexi.store/微信图片63_9.jpg"; // bundle payment QR
// ═══════════════════════════════════════════════════════════════════
// 【密令管理区】只需修改这里，其他代码不用动
// expires: "2026-12-31" = 到期日  |  expires: null = 永不过期
// 新增密令：https://emn178.github.io/online-tools/sha256.html 生成哈希后加一行
// ═══════════════════════════════════════════════════════════════════
const RESUME_SLOTS = [
  // ── 简历优化 专属密令（50个）──
  { hash: "5b1f31569efb205ec64c21a6f143fe8b27026baaa75ec91ab01436436e6e129a", expires: "2026-12-31" }, // resume_01: t4GWVB
  { hash: "c8d53db7fe17291ca1172c98052ddbe0bc4e695bf9d326a6033cfb2abf7de16d", expires: "2026-12-31" }, // resume_02: eHBk9BnJ
  { hash: "dd399903634002c8e526c28bbef6bdbab07ec1e643a2f87c06bc964fac989261", expires: "2026-12-31" }, // resume_03: Wqwn17D
  { hash: "7e501e3eb6fa4b69591f20d7094bda869954d52cc0b63bd61888ed80594e5ca8", expires: "2026-12-31" }, // resume_04: tnkU05Qk
  { hash: "346319b5c5056fe09ec42e644d0ae1cfba929f57fb577bdc69b5f01b9624d1a7", expires: "2026-12-31" }, // resume_05: jaZOsOM
  { hash: "b723bb4b9c5ea25c467736323d3b17cf32b7407c27db5477d2125f7e07300eb2", expires: "2026-12-31" }, // resume_06: DJkGnR
  { hash: "13680c0d2a30e63a44169c58c932d42cfc242da44a2156c87a747c80432ed087", expires: "2026-12-31" }, // resume_07: zfhTXJc
  { hash: "1aacb4fa3850359a490ba3028620ea47d0fcb3f2974009de9bcce3057bc83b6d", expires: "2026-12-31" }, // resume_08: Ie2I9z
  { hash: "34d5cc1e6c859d33b6c6183b8b83f4c57f542215ed712f0c0750f5d6c496644c", expires: "2026-12-31" }, // resume_09: J1C1v4
  { hash: "47df8bacae78a2ac2db6a10aa681cd98889b28c44a9639fbc6ae50e43da3f2b0", expires: "2026-12-31" }, // resume_10: LDPD4w
  { hash: "244b623b970c198beea7ba826b685c1019769c4846b3c7dfef98b20a4fd6848c", expires: "2026-12-31" }, // resume_11: WcJLmlYt
  { hash: "9b7be8737ed1b971709caeeecc04a3d20b2a3ae95ade0a7418f41b95d151124a", expires: "2026-12-31" }, // resume_12: e5Wq656v
  { hash: "a8ed7023f8d1e95f0f96b0547e5ec8c30eb350da9c8d6b6c35c6690ca006a117", expires: "2026-12-31" }, // resume_13: qXtoY3yQ
  { hash: "310cebefdbd243b5dd9450bb96300660d318c39f861b10ec3318b8ada27cd368", expires: "2026-12-31" }, // resume_14: pIakFvXk
  { hash: "9115fd42adbfe403a017a7bfa67885ae34553aab3d3dbdd87521c55ba3894b92", expires: "2026-12-31" }, // resume_15: jUYSt1
  { hash: "3622297283c78a5151f03f2ad8800e4dd54da6320a834380946948384b325510", expires: "2026-12-31" }, // resume_16: 4Qbqucz3
  { hash: "4a4ee301bfec85ba76795c2c37a799c64e6b6b9ec4f09cd78f86d32c5538653c", expires: "2026-12-31" }, // resume_17: xg7TcDf7
  { hash: "4bd9ea4fa57ad79414af62f50963149231b8bd892dbebd89ae0f09e0f23faf35", expires: "2026-12-31" }, // resume_18: uiyE2x
  { hash: "7b57dd8687d05e909c630afa1eef53eb1587f3bf9730b6beeaffeb82f39d9e86", expires: "2026-12-31" }, // resume_19: xQK3IQW
  { hash: "cf1443f80bda285e5673b489c618481cdf2e671a6b25fdec8fbdc6f02a79d8c5", expires: "2026-12-31" }, // resume_20: 2HMmDF
  { hash: "4f8771f8bdf175ea552347475468efcd23d56cdbbc66d8ce384ea2e86a32dbca", expires: "2026-12-31" }, // resume_21: WavryO4
  { hash: "dee21596903a391bad48a1ba0805065fc01cfebc6258691018244e75cfe7165f", expires: "2026-12-31" }, // resume_22: K4LJ5p
  { hash: "b3bfe717a05dc3d49a2f060756a64483fedacd0f6cb631d5152731a13ba9ca9d", expires: "2026-12-31" }, // resume_23: lFsLULE
  { hash: "2e43bf8407ac4b2fd177e1405572e9d08115466c2672a9bce29a937401c14f70", expires: "2026-12-31" }, // resume_24: rJdwoOWX
  { hash: "9fdfd18e556344114395f42d647b418e0bbde52d02cd3c6dc940cf6ffa148e88", expires: "2026-12-31" }, // resume_25: wdQqdt
  { hash: "a34392d45fcd83759caf25a449289505b38165d6cc764c5b773e5caf26a7b9a9", expires: "2026-12-31" }, // resume_26: 7QuaKM4w
  { hash: "96cb98262e8e4b8600e55e4042b5053fd7e476d9a93878d5612a9f514a2343a7", expires: "2026-12-31" }, // resume_27: S80fqX
  { hash: "b08cfdc55d010e470bffbd82645e9cceee3a764fce4486037fb55f2a2e775001", expires: "2026-12-31" }, // resume_28: hu5s1t
  { hash: "85c655bfec4818b105b0aa98a6bfae8681f9bab1760b058e253fedec0d356892", expires: "2026-12-31" }, // resume_29: 0gdLDQuv
  { hash: "b2a2a78080b22071566dbf77759926afb627e2a915ddaff70839e01da6a05efd", expires: "2026-12-31" }, // resume_30: QTMHXIBA
  { hash: "30ede8bb54d36048696ce5a2b3a59c638d847fa2b2f53c0bf9ff2df4096443aa", expires: "2026-12-31" }, // resume_31: LlgaaNa
  { hash: "5450bab3a9e84033f2c75521143c7c9f4658f5efa63f78d017645876b47d1a5d", expires: "2026-12-31" }, // resume_32: mkNxVv0U
  { hash: "c30029f4e592c89a375626e8048f34f46552e8da7349d6756e9d8a4ccea822dc", expires: "2026-12-31" }, // resume_33: Hw4XYWV
  { hash: "c2f6df71b91a8bd5cd7292c780b490e464061c1ddb20dec34b83ab082db7a39b", expires: "2026-12-31" }, // resume_34: LghGRTXp
  { hash: "09d7f0e25b3f94829eabf37c2e429e14a3319ce6bc9325f784c03e2f040a09dc", expires: "2026-12-31" }, // resume_35: S2naUH8
  { hash: "708387a7293b8e0264e13b42594ff5bc03891b3d8c7830006af8250720cdf2cc", expires: "2026-12-31" }, // resume_36: uSVRaD
  { hash: "df9defa48b99da9f3fe3ebe0df8cc1def3422e444d840ef05910102816440746", expires: "2026-12-31" }, // resume_37: EfbWieI1
  { hash: "0739ce5ebcca38645b2dc1e8555eee61f31c01a41765699276352b524919c511", expires: "2026-12-31" }, // resume_38: jxm2gRT
  { hash: "bbcb285c62ba06015a4b525f8aa6e4245eaa3b40d1ac6804d923b09af364f67d", expires: "2026-12-31" }, // resume_39: 9wzI6fX
  { hash: "3dbe1410b463694b6e1d5b5d2d446ea8e225db15c1dbea1b570f41d12fafc804", expires: "2026-12-31" }, // resume_40: UY0zEb2g
  { hash: "19c29ddcb722ce6e2c4bc78bc8b0cfcfdc5d1ab1b1fdba445811709cba102576", expires: "2026-12-31" }, // resume_41: s75t7sw0
  { hash: "e99edf30a725420fe8bbdb14fa99a610c69f351cf0be2c65bf73de291a7bb47c", expires: "2026-12-31" }, // resume_42: ei3fMV3w
  { hash: "1883959d28307041c551cf97da29b12805a06c5aa53b24f2ea68d4f1775b8c3e", expires: "2026-12-31" }, // resume_43: S1LLXQ
  { hash: "7ddbd6a75983b9e6be58211c2137f058e7bddb6a95699b4bff4895f8edfe2331", expires: "2026-12-31" }, // resume_44: jKWFnMs
  { hash: "34cf2dbd0298232f71fe0e4d8fa0b1b2f6e380df390bb88636da40b65cced1b2", expires: "2026-12-31" }, // resume_45: BQ15aFwR
  { hash: "c2e24aa715473c02dadb55f723ec424fdcf980216bce748908fe33f4fac40d40", expires: "2026-12-31" }, // resume_46: D7aiSiRa
  { hash: "c974940edc1e7c787d0b21aef8716bf526dd88e2e9add761872bba3f9b3b5fc2", expires: "2026-12-31" }, // resume_47: mMKytz
  { hash: "d0435fea5d3d49638ad1f1475728e1fe03cc918bc5cb861fbe8ce95901563d14", expires: "2026-12-31" }, // resume_48: uBDTWzjm
  { hash: "36da359bfd013aa9d90fffde278301df730820fa51cb1c54272c41a5111f68c8", expires: "2026-12-31" }, // resume_49: eQDV6ee6
  { hash: "10e844ad7bac5dad39b5f55c2719eba956c9133f0188765c0521519cbdb015ef", expires: "2026-12-31" }, // resume_50: GXjQTV
  // ── 三合一套餐（50个）── 三个工具都能用
  { hash: "58852f6a56b025b0cd9ac272a07d2b5d7c00d91f7d3468e5d01efd334ff152f2", expires: "2026-12-31" }, // bundle_01: 0cEDhk
  { hash: "a532d5100bd2221eb99b1d8798463eaf027f4480b2f52201468072374236ec4d", expires: "2026-12-31" }, // bundle_02: rHgEqLNs
  { hash: "2a3ee50e7856ca852a541591fc1fa765e71a277f41f80842ed24cc5ca7ea6d82", expires: "2026-12-31" }, // bundle_03: heIdo2c
  { hash: "7320595c93c7afb29ff3fa73da39ac0a410e425b8011b3c0e293923c235caea3", expires: "2026-12-31" }, // bundle_04: drHId8ia
  { hash: "4260d0510ce65a89f3e0007a06df3ef81fa1c55ebb51a465c1a708d06b584764", expires: "2026-12-31" }, // bundle_05: 0Xikx3o
  { hash: "52b7a3d82cd50dd846285e0a96c3d62361a0c8a76ce535924c5c1ce3af6ab133", expires: "2026-12-31" }, // bundle_06: S3vSbTl
  { hash: "d1ba3f041d5fe410f47a812aea85b5d1dbfab31ecfb5efc9ee541e4e4fba2c3f", expires: "2026-12-31" }, // bundle_07: WqvXp2pG
  { hash: "6cdd8745823b2497e9e8613f85e17518d989d2a2c4f789384c03c18111f8aa32", expires: "2026-12-31" }, // bundle_08: VFjxqn
  { hash: "01781a622e636a1da0d5d43fc7009afc822cf49e7efd30d1ebc00a5e129f4652", expires: "2026-12-31" }, // bundle_09: LkP1JD5F
  { hash: "264b5c83d72e1be9259f5c2ed6c678f4beb3aa66476a7eb816e4f5af1fcf71e1", expires: "2026-12-31" }, // bundle_10: xZYACdP
  { hash: "13a2f4212cf79eeb0da218cf8e7a051334e7151e421d92f6f92b1c1371f42063", expires: "2026-12-31" }, // bundle_11: b6milAy
  { hash: "5c1d3c357474db6ca1f6ab83057b029476e5319ee7c2f5dfa3f619c8fd9b97fa", expires: "2026-12-31" }, // bundle_12: IsScV7
  { hash: "1b2cfa5c1a319af4415b81a04056ba90c4c4097daeb91b51f7d26d10982a600e", expires: "2026-12-31" }, // bundle_13: RbWljos4
  { hash: "665bcc8cbf827c6cb8219c5290dfd6699c5b03074f86192096603339ea04d325", expires: "2026-12-31" }, // bundle_14: 94cQpJ
  { hash: "cdaf5b35eca921486558e522056a44e0f87b98d5b91eac25a272c76bd808a2d7", expires: "2026-12-31" }, // bundle_15: IMWNWi
  { hash: "848db25e07ac778bc9a6348a322a4278ef253472cb46724ddfc7e2c37aa415e8", expires: "2026-12-31" }, // bundle_16: l6ycMTR
  { hash: "315a9bfd7a49fc1b60887e84fff7a17224b75001ebb1937895b3b74aafd21d58", expires: "2026-12-31" }, // bundle_17: D0QR7NZ
  { hash: "826fcada952d869788335119b62c99fa5b78729af1fffd020e8f2073853dba01", expires: "2026-12-31" }, // bundle_18: ClhNAEE
  { hash: "67be03865906827bfbcfe289f71ba5c42baa5fc5fe9578ff202c066eb57e5631", expires: "2026-12-31" }, // bundle_19: UTWUUgx
  { hash: "9a86db34888fddd08a97a1d9afd2991aae7e0aabece009432543a479fcf5da1c", expires: "2026-12-31" }, // bundle_20: rZ92vfvg
  { hash: "6c9902fff46080cef3de43ef37a7711b0a0a70c8c724c807b7570787f685cc7d", expires: "2026-12-31" }, // bundle_21: RBfHwE
  { hash: "6657152d15b88a211587cc3615190d1f71853810b44c67697f70660550000e36", expires: "2026-12-31" }, // bundle_22: Z4DxlGX2
  { hash: "d106a985922fbcd3471f958cf1402575095ff0e95767b6c7028ff10fa573c38e", expires: "2026-12-31" }, // bundle_23: pYJ6lW
  { hash: "c49f4981e4a074eede4298d38be2f450ffebc13a1010cc46175b01a21189df63", expires: "2026-12-31" }, // bundle_24: 795v4Eu
  { hash: "006cec3f3db67ff0e3fe9461ca1ced69dea62fc8215bc7cba920c62a9d2b5a97", expires: "2026-12-31" }, // bundle_25: ImSleiC
  { hash: "792a29e23d04e7d712fa393697f68ed877c077084abbc63729a948946aae3293", expires: "2026-12-31" }, // bundle_26: 2frKYJFR
  { hash: "e2555dfe8f855bde18b76e542d1d63f64119a7f042547ef6278e4cc30489e9b6", expires: "2026-12-31" }, // bundle_27: 5CgEZxQ
  { hash: "019ff2d0e515afe70754618f3f4ad87f6050daba55e2bc7c26bc354f10dda6d1", expires: "2026-12-31" }, // bundle_28: 1udglz
  { hash: "ef58498ab5c679d71c94550456d5911a8984d84940a71b32c373e5f6754729d4", expires: "2026-12-31" }, // bundle_29: SgpZDG
  { hash: "049c56dc2c2abfb14d651fa14f96a02c77d1d5847caba5316eeb7c1077d26161", expires: "2026-12-31" }, // bundle_30: G8II2s
  { hash: "76d3be96592da36ad462a4c5cab6231351af66a68dce11edd248680a254bf604", expires: "2026-12-31" }, // bundle_31: 1luiY72
  { hash: "e8fde2b707cf66a31d886c34f9b324a5acc77d8af26f93e27be23279ae8c8004", expires: "2026-12-31" }, // bundle_32: tsq7gas
  { hash: "7dcd1d15897734e1777633a4b7180454f8d898ddf5eeeb5f1db5e5e4262e3cc3", expires: "2026-12-31" }, // bundle_33: oM980t3I
  { hash: "7c20a5951bfba07c8d1b28f06df624ef5a87354edfdd1c13140650b1fcbb41a0", expires: "2026-12-31" }, // bundle_34: dKN94k
  { hash: "1169547ff4ed0cd9115c782152f62752b4a20a8ad5a7ccee49161f155139be76", expires: "2026-12-31" }, // bundle_35: mo5IJyFu
  { hash: "14d143b5802041d0ffd7b116d349a4b4f3047c92dd89b1e57cbbbf0a1bd0e75d", expires: "2026-12-31" }, // bundle_36: o8xPBX
  { hash: "b6c9aed6243a31d2aa044a89b8a77c4ad8b00b5d56136b31d569a49e86bcac43", expires: "2026-12-31" }, // bundle_37: Fp925V
  { hash: "fb526263de18fd09ac557f1e05b618476c5d6525af1a1ec60c69e6629c951d90", expires: "2026-12-31" }, // bundle_38: c2RSAd
  { hash: "5ca66339f6bab8377cd71aa930552765df3484076dee77b7ca96dc4ecd5268f6", expires: "2026-12-31" }, // bundle_39: PUudzd
  { hash: "d68ab55d88e56e8f08ac0de3d42c29783fc1cbd764e8e0a60777dfae874c9f15", expires: "2026-12-31" }, // bundle_40: ayqx9mJ
  { hash: "43ee433eb2258fdc141d9eaf22b86c5deaa3ca6560aa8fb09429fb846c4aa0ee", expires: "2026-12-31" }, // bundle_41: ClNG4oVe
  { hash: "1163b6f653c2d98e48346197c0e3bb0a76e2dd15a1c1480618a1cc93feb5d7e9", expires: "2026-12-31" }, // bundle_42: j5Wqd4
  { hash: "8ab8a9556b62a8d8904ab20d181d4aee03a670ec2cc4041f527c85260ad452f6", expires: "2026-12-31" }, // bundle_43: PiAIKP
  { hash: "d7bdad3f7ce8705de9e6ddd5f213099f2695be92ea60b67dba589150b5fa37be", expires: "2026-12-31" }, // bundle_44: ica2rOpx
  { hash: "632a3da7c4d537b87240354c9a7941731a7a1dc1e6136493519ed3722bbaf173", expires: "2026-12-31" }, // bundle_45: QyaDAVZs
  { hash: "5907ed8aa403cd105d7093506cfe88dbc4bea92b8ce82070f1b6714899d1cb52", expires: "2026-12-31" }, // bundle_46: PfzVnz
  { hash: "62f4b0596d1183f04e2ce29e6005da8f22bbfdf87ec165bed2c3cb6ab7b8e727", expires: "2026-12-31" }, // bundle_47: xtcvz7VW
  { hash: "8a1544a64535241d60de9edd415286c9c335498d58a55699e82450b64258aaf3", expires: "2026-12-31" }, // bundle_48: nCSDku
  { hash: "ec3116cfb0847a6e146b1d2317640d4011647de3ef12be924b7a40796a15e2b4", expires: "2026-12-31" }, // bundle_49: uL2FtEv
  { hash: "22dc92a9ec1ae254d929178cc20d570c93a061afe94bf528cab6a46a1fac181b", expires: "2026-12-31" }, // bundle_50: 32POVnq
];
function checkResumeSlot(hash) {
  const slot = RESUME_SLOTS.find(s => s.hash === hash);
  if (!slot) return false;
  if (!slot.expires) return true;
  const expiry = new Date(slot.expires);
  expiry.setHours(23, 59, 59, 999);
  return new Date() <= expiry;
}
async function resumeSha(s){const b=await crypto.subtle.digest("SHA-256",new TextEncoder().encode(s));return Array.from(new Uint8Array(b)).map(x=>x.toString(16).padStart(2,"0")).join("");}
const resumeIsUnlocked=()=>{try{return localStorage.getItem(RESUME_SK)==="true";}catch{return false;}};
const resumeSetUnlocked=()=>{try{localStorage.setItem(RESUME_SK,"true");}catch{}};

function HistoryPanel({ onSelect }) {
  const [hist, setHist] = useState(() => loadHistory());
  const [open, setOpen] = useState(false);

  if (!hist.length) return null;

  return (
    <div style={{ marginTop: 12 }}>
      <button onClick={() => setOpen(!open)} style={{
        width:"100%", background:"none", border:"1px solid var(--border)",
        borderRadius:8, color:"var(--ink3)", fontSize:11, fontWeight:700,
        padding:"6px", cursor:"pointer", fontFamily:"inherit", textAlign:"left",
        display:"flex", justifyContent:"space-between",
      }}>
        <span>🕐 最近记录 ({hist.length})</span>
        <span>{open?"▲":"▼"}</span>
      </button>
      {open && (
        <div style={{ marginTop:4 }}>
          {hist.map(h => (
            <div key={h.id} onClick={() => onSelect(h.resume)} style={{
              padding:"8px 10px", borderRadius:6, marginBottom:4,
              background:"var(--surface2)", cursor:"pointer",
              border:"1px solid var(--border)", transition:"all .15s",
            }}
            onMouseEnter={e=>e.currentTarget.style.borderColor="var(--emerald)"}
            onMouseLeave={e=>e.currentTarget.style.borderColor="var(--border)"}
            >
              <div style={{fontSize:12,fontWeight:700,color:"var(--ink1)"}}>{h.name}</div>
              <div style={{fontSize:10,color:"var(--ink3)",marginTop:1}}>{h.title} · {h.ts}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ResumePaywall({onUnlock,onClose}){
  const[pw,setPw]=useState("");const[err,setErr]=useState(false);const[ok,setOk]=useState(false);
  // qrType: null | "single" | "bundle"
  const[qrType,setQrType]=useState(null);
  const sub=async()=>{if(!pw.trim())return;const h=await resumeSha(pw.trim());if(checkResumeSlot(h)){setOk(true);resumeSetUnlocked();setTimeout(onUnlock,1200);}else{setErr(true);setTimeout(()=>setErr(false),1500);}};
  return(<div onClick={e=>{if(e.target===e.currentTarget)onClose();}} style={{position:"fixed",inset:0,background:"rgba(0,0,0,.92)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(10px)"}}>
    <div style={{background:"#0b1020",border:"1px solid #1a2a44",borderRadius:20,padding:"36px 32px",maxWidth:440,width:"90%",boxShadow:"0 24px 80px #000"}}>
      {ok?(<div style={{textAlign:"center",padding:"24px 0"}}><div style={{fontSize:52}}>🎉</div><div style={{fontSize:20,fontWeight:800,color:"#22c55e",margin:"12px 0 6px"}}>解锁成功！</div></div>):(
      <div>
        <div style={{textAlign:"center",marginBottom:20}}>
          <div style={{fontSize:32,marginBottom:8}}>📄</div>
          <div style={{fontSize:18,fontWeight:800,color:"#e8f0fe",marginBottom:12}}>AI 简历优化 · 选择套餐</div>
          {/* ── QR 弹层 ── */}
          {qrType && (
            <div onClick={()=>setQrType(null)} style={{
              position:"fixed",inset:0,background:"rgba(0,0,0,.85)",zIndex:10001,
              display:"flex",alignItems:"center",justifyContent:"center",backdropFilter:"blur(6px)",
            }}>
              <div onClick={e=>e.stopPropagation()} style={{
                background:"#0b1020",border:"1px solid #2a3a5a",borderRadius:20,
                padding:"28px 24px",textAlign:"center",maxWidth:280,width:"90%",
              }}>
                <div style={{fontSize:13,fontWeight:800,color:"#e8f0fe",marginBottom:4}}>
                  {qrType==="single"?"单工具 ¥"+RESUME_SINGLE_PRICE:"三工具套餐 ¥"+RESUME_BUNDLE_PRICE}
                </div>
                <div style={{fontSize:11,color:"#4a5a7a",marginBottom:16}}>
                  扫码付款后截图联系获取密令
                </div>
                {/* ── 替换 src 为你的真实收款二维码图片链接 ── */}
                <img
                  src={qrType==="single" ? QRCODE_SINGLE : QRCODE_BUNDLE}
                  alt="付款二维码"
                  style={{width:180,height:180,borderRadius:12,border:"2px solid #1a2a44",
                    background:"#fff",display:"block",margin:"0 auto 16px",objectFit:"contain"}}
                  onError={e=>{e.target.style.display="none";e.target.nextSibling.style.display="flex";}}
                />
                <div style={{
                  width:180,height:180,borderRadius:12,border:"2px dashed #2a3a5a",
                  background:"#0a1020",display:"none",alignItems:"center",justifyContent:"center",
                  margin:"0 auto 16px",flexDirection:"column",gap:8,
                }}>
                  <div style={{fontSize:32}}>📷</div>
                  <div style={{fontSize:11,color:"#3a4a6a",textAlign:"center",padding:"0 12px"}}>
                    二维码加载失败<br/>请联系 {RESUME_CONTACT}
                  </div>
                </div>
                <div style={{fontSize:12,color:"#4f9cf9",fontWeight:700}}>{RESUME_CONTACT}</div>
                <button onClick={()=>setQrType(null)} style={{
                  marginTop:14,width:"100%",background:"none",border:"1px solid #1a2a44",
                  color:"#3a4a6a",borderRadius:8,padding:"8px",fontSize:12,cursor:"pointer",fontFamily:"inherit",
                }}>关闭</button>
              </div>
            </div>
          )}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:14}}>
            <div
              onClick={()=>setQrType("single")}
              style={{background:"rgba(251,146,60,.08)",border:"1.5px solid rgba(251,146,60,.3)",borderRadius:12,padding:"12px 10px",textAlign:"center",cursor:"pointer",transition:"all .15s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(251,146,60,.7)"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(251,146,60,.3)"}
            >
              <div style={{fontSize:11,color:"#fb923c",fontWeight:700,marginBottom:4}}>单工具</div>
              <div style={{fontSize:24,fontWeight:900,color:"#fb923c"}}>¥{RESUME_SINGLE_PRICE}</div>
              <div style={{fontSize:10,color:"#7a5030",marginTop:2}}>仅简历优化</div>
              <div style={{fontSize:10,color:"#fb923c",marginTop:6,opacity:.7}}>点击扫码付款 →</div>
            </div>
            <div
              onClick={()=>setQrType("bundle")}
              style={{background:"rgba(16,185,129,.08)",border:"1.5px solid rgba(16,185,129,.35)",borderRadius:12,padding:"12px 10px",textAlign:"center",cursor:"pointer",position:"relative",transition:"all .15s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(16,185,129,.7)"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(16,185,129,.35)"}
            >
              <div style={{position:"absolute",top:-8,left:"50%",transform:"translateX(-50%)",background:"#10b981",color:"#fff",fontSize:9,fontWeight:800,padding:"2px 8px",borderRadius:20}}>推荐</div>
              <div style={{fontSize:11,color:"#10b981",fontWeight:700,marginBottom:4}}>三工具套餐</div>
              <div style={{fontSize:24,fontWeight:900,color:"#10b981"}}>¥{RESUME_BUNDLE_PRICE}</div>
              <div style={{fontSize:10,color:"#3a7a5a",marginTop:2}}>学习+简历+去AI化</div>
              <div style={{fontSize:10,color:"#10b981",marginTop:6,opacity:.7}}>点击扫码付款 →</div>
            </div>
          </div>
          <div style={{fontSize:12,color:"#4a5a7a"}}>👆 点击套餐扫码付款 · 付款后发截图给 {RESUME_CONTACT} 获取密令 🔑</div>
        </div>
        <div style={{background:"#0a1020",border:"1px solid #1a2a44",borderRadius:12,padding:"14px 18px",marginBottom:16}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{background:"#1a2a4a",border:"1px solid #2a4a8a",borderRadius:10,padding:"10px 16px",flex:1}}>
              <div style={{fontSize:11,color:"#4a6aaa",marginBottom:2}}>联系账号</div>
              <div style={{fontSize:16,fontWeight:800,color:"#4f9cf9",fontFamily:"monospace",letterSpacing:1}}>{RESUME_CONTACT}</div>
            </div>
            <button onClick={()=>navigator.clipboard?.writeText(RESUME_CONTACT)} style={{background:"none",border:"1px solid #1a2a44",color:"#3a5a8a",borderRadius:8,padding:"8px 14px",fontSize:12,cursor:"pointer",fontFamily:"inherit"}}>复制</button>
          </div>
        </div>
        <div style={{marginBottom:14}}>
          <input type="password" placeholder="输入密令解锁..." value={pw} onChange={e=>{setPw(e.target.value);setErr(false);}} onKeyDown={e=>e.key==="Enter"&&sub()} style={{width:"100%",background:"#0a1020",border:`1.5px solid ${err?"#ef4444":"#1a2a44"}`,borderRadius:10,color:"#e8f0fe",padding:"11px 16px",fontSize:14,fontFamily:"inherit",outline:"none",letterSpacing:2,boxSizing:"border-box"}}/>
          {err&&<div style={{fontSize:12,color:"#ef4444",marginTop:5}}>密令不正确</div>}
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={sub} style={{flex:1,background:pw?"linear-gradient(135deg,#2a5298,#4f9cf9)":"#1a2444",color:pw?"#fff":"#3a4a6a",border:"none",borderRadius:10,padding:"12px",fontSize:14,fontWeight:700,cursor:pw?"pointer":"default",fontFamily:"inherit"}}>解锁</button>
          <button onClick={onClose} style={{background:"none",border:"1px solid #1a2a44",color:"#3a4a6a",borderRadius:10,padding:"12px 16px",fontSize:13,cursor:"pointer",fontFamily:"inherit"}}>稍后</button>
        </div>
      </div>)}
    </div>
  </div>);
}

/* GLOBAL STYLES */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300;9..144,600;9..144,800&family=DM+Sans:wght@300;400;500;600;700&family=Lora:ital,wght@0,400;0,600;1,400&family=JetBrains+Mono:wght@400;500&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

    :root {
      --coal:   #1c1917; --coal2: #292524; --coal3: #44403c;
      --sand:   #fafaf8; --sand2: #f5f4f1; --sand3: #e8e5e0;
      --white:  #ffffff; --border: #e2ddd8;
      --ink:    #1c1917; --ink2:  #57534e; --ink3:  #a8a29e;
      --emerald:#059669; --em2:   #10b981; --em3:   #d1fae5;
      --amber:  #d97706; --amb2:  #f59e0b; --amb3:  #fef3c7;
      --sky:    #0284c7; --sky2:  #38bdf8; --sky3:  #e0f2fe;
      --rose:   #e11d48; --rose3: #ffe4e6;
      --sh:     0 1px 3px rgba(28,25,23,.06), 0 4px 16px rgba(28,25,23,.05);
      --sh2:    0 8px 32px rgba(28,25,23,.12);
    }

    html, body { height: 100%; font-family: 'DM Sans', sans-serif; background: var(--sand); color: var(--ink); }
    ::-webkit-scrollbar { width: 4px; height: 4px; }
    ::-webkit-scrollbar-thumb { background: var(--sand3); border-radius: 2px; }

    @keyframes fadeUp   { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
    @keyframes fadeIn   { from{opacity:0} to{opacity:1} }
    @keyframes popIn    { from{opacity:0;transform:scale(.94)} to{opacity:1;transform:scale(1)} }
    @keyframes spin     { to{transform:rotate(360deg)} }
    @keyframes pulse    { 0%,100%{opacity:1} 50%{opacity:.45} }
    @keyframes shimmer  { 0%{background-position:200% 0} 100%{background-position:-200% 0} }
    @keyframes barFill  { from{width:0} to{width:var(--w,60%)} }
    @keyframes slideIn  { from{opacity:0;transform:translateX(12px)} to{opacity:1;transform:translateX(0)} }

    .fu  { animation: fadeUp .38s ease both; }
    .fi  { animation: fadeIn .3s ease both; }
    .pop { animation: popIn .3s ease both; }
    .si  { animation: slideIn .32s ease both; }
    .spin-a { animation: spin .75s linear infinite; }
    .pls { animation: pulse 1.4s ease infinite; }

    /* ── App shell ── */
    .app-shell { display:flex; height:100vh; overflow:hidden; }
    .sidebar {
      width: 240px; flex-shrink: 0; background: var(--coal);
      display: flex; flex-direction: column; overflow: hidden;
    }
    .main-area { flex:1; overflow-y:auto; background: var(--sand); }

    /* ── Sidebar ── */
    .sb-logo { padding:22px 20px 16px; border-bottom:1px solid rgba(255,255,255,.07); }
    .sb-logo-text { font-family:'Fraunces',serif; font-size:18px; font-weight:800; color:#fff; letter-spacing:-.3px; }
    .sb-logo-sub  { font-size:10px; color:rgba(255,255,255,.35); letter-spacing:.8px; font-weight:500; margin-top:2px; }
    .sb-steps { padding:16px 12px; flex:1; }
    .sb-step {
      display:flex; align-items:center; gap:10px; padding:9px 12px;
      border-radius:9px; margin-bottom:3px; cursor:pointer; transition:all .14s;
      color:rgba(255,255,255,.45); font-size:13px; font-weight:500;
    }
    .sb-step:hover { background:rgba(255,255,255,.05); color:rgba(255,255,255,.7); }
    .sb-step.active { background:rgba(5,150,105,.2); color:#10b981; }
    .sb-step.done   { color:rgba(255,255,255,.6); }
    .sb-step.locked { opacity:.35; cursor:not-allowed; }
    .sb-num {
      width:22px; height:22px; border-radius:6px; flex-shrink:0;
      display:flex; align-items:center; justify-content:center;
      font-size:11px; font-weight:700; font-family:'JetBrains Mono',monospace;
      background:rgba(255,255,255,.08); color:inherit;
    }
    .sb-step.active .sb-num { background:var(--emerald); color:#fff; }
    .sb-step.done   .sb-num { background:rgba(255,255,255,.15); }
    .sb-bottom { padding:14px 16px; border-top:1px solid rgba(255,255,255,.06); }
    .sb-badge {
      background:rgba(5,150,105,.15); border:1px solid rgba(5,150,105,.3);
      color:var(--em2); border-radius:6px; padding:6px 10px;
      font-size:11px; font-weight:700; text-align:center; letter-spacing:.3px;
    }

    /* ── Buttons ── */
    .btn {
      display:inline-flex; align-items:center; justify-content:center; gap:7px;
      cursor:pointer; border:none; font-family:'DM Sans',sans-serif; font-weight:600;
      border-radius:10px; transition:all .15s; user-select:none;
    }
    .btn:disabled { opacity:.38; cursor:not-allowed !important; }
    .btn-primary { background:var(--emerald); color:#fff; padding:11px 26px; font-size:14px; }
    .btn-primary:not(:disabled):hover { background:var(--em2); box-shadow:0 5px 18px rgba(5,150,105,.35); transform:translateY(-1px); }
    .btn-secondary { background:var(--white); color:var(--ink2); border:1.5px solid var(--border); padding:9px 20px; font-size:13px; }
    .btn-secondary:hover { border-color:var(--coal3); color:var(--ink); }
    .btn-ghost { background:transparent; color:var(--ink3); padding:7px 14px; font-size:12px; }
    .btn-ghost:hover { color:var(--ink); background:var(--sand2); border-radius:8px; }
    .btn-amber { background:var(--amber); color:#fff; padding:9px 20px; font-size:13px; }
    .btn-amber:hover { background:var(--amb2); }
    .btn-sky { background:var(--sky); color:#fff; padding:9px 20px; font-size:13px; }
    .btn-sm { padding:6px 14px; font-size:12px; border-radius:8px; }
    .btn-icon { padding:8px; border-radius:8px; background:var(--sand2); border:1px solid var(--border); color:var(--ink2); font-size:15px; }
    .btn-icon:hover { border-color:var(--coal3); }

    /* ── Cards ── */
    .card { background:var(--white); border:1px solid var(--border); border-radius:16px; box-shadow:var(--sh); }
    .card-em { background:var(--em3); border:1px solid #a7f3d0; border-radius:12px; }
    .card-amb{ background:var(--amb3);border:1px solid #fde68a;border-radius:12px; }
    .card-sky{ background:var(--sky3);border:1px solid #bae6fd;border-radius:12px; }
    .card-rose{background:var(--rose3);border:1px solid #fecdd3;border-radius:12px; }

    /* ── Upload zone ── */
    .upload-zone {
      border:2.5px dashed var(--sand3); border-radius:20px; padding:56px 32px;
      text-align:center; cursor:pointer; transition:all .2s;
      background:var(--white);
    }
    .upload-zone:hover, .upload-zone.over {
      border-color:var(--emerald); background:#f0fdf9;
    }

    /* ── Progress ── */
    .prog-track { height:4px; background:var(--sand3); border-radius:2px; overflow:hidden; }
    .prog-fill  { height:100%; border-radius:2px; background:linear-gradient(90deg,var(--emerald),var(--em2)); transition:width .5s ease; }
    .shimmer-row {
      height:14px; border-radius:6px; margin-bottom:8px;
      background: linear-gradient(90deg, var(--sand2) 25%, var(--sand3) 50%, var(--sand2) 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }

    /* ── Tag / Badge ── */
    .tag {
      display:inline-flex; align-items:center; gap:5px;
      padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; letter-spacing:.3px;
    }
    .tag-em  { background:var(--em3); color:var(--emerald); }
    .tag-amb { background:var(--amb3);color:var(--amber); }
    .tag-sky { background:var(--sky3);color:var(--sky); }
    .tag-coal{ background:var(--sand2);color:var(--coal3); border:1px solid var(--sand3); }

    /* ── Optimize mode chips ── */
    .mode-chip {
      padding:8px 16px; border-radius:10px; font-size:12px; font-weight:600;
      border:1.5px solid var(--border); background:var(--white); cursor:pointer;
      color:var(--ink3); transition:all .14s; text-align:center;
    }
    .mode-chip:hover { border-color:var(--emerald); color:var(--emerald); }
    .mode-chip.on { background:var(--emerald); color:#fff; border-color:var(--emerald); }

    /* ── Panel tabs ── */
    .panel-tab {
      padding:9px 18px; font-size:12px; font-weight:600; border:none; background:transparent;
      cursor:pointer; color:var(--ink3); border-bottom:2.5px solid transparent;
      transition:all .14s; font-family:'DM Sans',sans-serif; white-space:nowrap;
    }
    .panel-tab.on { color:var(--emerald); border-bottom-color:var(--emerald); }

    /* ── Resume Preview ── */
    .resume-preview {
      background:#fff; box-shadow: 0 2px 8px rgba(0,0,0,.08), 0 16px 48px rgba(0,0,0,.12);
      min-height:900px;
    }

    /* ── Template: Modern ── */
    .tpl-modern { font-family:'DM Sans',sans-serif; padding:40px 48px; }
    .tpl-modern .r-name { font-size:28px; font-weight:700; color:#1c1917; letter-spacing:-.5px; }
    .tpl-modern .r-title { font-size:14px; color:#059669; font-weight:600; margin-top:3px; }
    .tpl-modern .r-contact { display:flex; gap:16px; flex-wrap:wrap; margin-top:8px; font-size:12px; color:#57534e; }
    .tpl-modern .r-divider { height:2px; background:linear-gradient(90deg,#059669,#10b981,transparent); margin:16px 0; }
    .tpl-modern .r-section-title { font-size:11px; font-weight:800; letter-spacing:1.2px; text-transform:uppercase; color:#059669; margin-bottom:10px; }
    .tpl-modern .r-exp-company { font-size:14px; font-weight:700; color:#1c1917; }
    .tpl-modern .r-exp-title { font-size:13px; color:#44403c; }
    .tpl-modern .r-exp-period { font-size:11px; color:#a8a29e; }
    .tpl-modern .r-bullet { font-size:12.5px; color:#44403c; line-height:1.75; padding-left:14px; position:relative; margin-bottom:4px; }
    .tpl-modern .r-bullet::before { content:'▸'; position:absolute; left:0; color:#059669; }
    .tpl-modern .r-skill-tag { display:inline-block; background:#f0fdf9; border:1px solid #a7f3d0; color:#059669; font-size:11px; font-weight:600; padding:3px 10px; border-radius:5px; margin:3px; }

    /* ── Template: Classic ── */
    .tpl-classic { font-family:'Lora',serif; padding:40px 48px; background:#fff; }
    .tpl-classic .r-name { font-size:26px; font-weight:600; color:#1d4ed8; text-align:center; }
    .tpl-classic .r-title { font-size:13px; color:#57534e; text-align:center; margin-top:3px; font-style:italic; }
    .tpl-classic .r-contact { display:flex; gap:20px; justify-content:center; flex-wrap:wrap; margin-top:8px; font-size:12px; color:#57534e; font-family:'DM Sans',sans-serif; }
    .tpl-classic .r-divider { height:2px; background:linear-gradient(90deg,#1d4ed8,#3b82f6,transparent); margin:14px 0; }
    .tpl-classic .r-section-title { font-size:13px; font-weight:600; color:#1d4ed8; text-transform:uppercase; letter-spacing:1.5px; border-bottom:1px solid #e2ddd8; padding-bottom:4px; margin-bottom:10px; font-family:'DM Sans',sans-serif; }
    .tpl-classic .r-exp-company { font-size:14px; font-weight:600; color:#1c1917; }
    .tpl-classic .r-exp-title { font-size:13px; color:#57534e; font-style:italic; }
    .tpl-classic .r-exp-period { font-size:11px; color:#a8a29e; font-family:'DM Sans',sans-serif; }
    .tpl-classic .r-bullet { font-size:12.5px; color:#44403c; line-height:1.75; padding-left:14px; position:relative; margin-bottom:4px; font-family:'DM Sans',sans-serif; }
    .tpl-classic .r-bullet::before { content:'•'; position:absolute; left:2px; }
    .tpl-classic .r-skill-tag { font-size:12px; color:#44403c; font-family:'DM Sans',sans-serif; }
    .tpl-classic .r-skill-tag::after { content:' · '; }
    .tpl-classic .r-skill-tag:last-child::after { content:''; }

    /* ── Template: Minimal ── */
    .tpl-minimal { font-family:'DM Sans',sans-serif; padding:48px 56px; background:#fff; }
    .tpl-minimal .r-name { font-size:32px; font-weight:300; color:#1c1917; letter-spacing:-1px; }
    .tpl-minimal .r-title { font-size:13px; color:#a8a29e; font-weight:400; margin-top:4px; letter-spacing:.5px; }
    .tpl-minimal .r-contact { display:flex; gap:20px; flex-wrap:wrap; margin-top:10px; font-size:12px; color:#a8a29e; }
    .tpl-minimal .r-divider { height:1px; background:#e8e5e0; margin:20px 0; }
    .tpl-minimal .r-section-title { font-size:10px; font-weight:700; letter-spacing:2px; text-transform:uppercase; color:#a8a29e; margin-bottom:14px; }
    .tpl-minimal .r-exp-company { font-size:14px; font-weight:600; color:#1c1917; }
    .tpl-minimal .r-exp-title { font-size:13px; color:#57534e; }
    .tpl-minimal .r-exp-period { font-size:11px; color:#d4cfc8; }
    .tpl-minimal .r-bullet { font-size:12.5px; color:#57534e; line-height:1.8; padding-left:0; margin-bottom:4px; }
    .tpl-minimal .r-skill-tag { font-size:12px; color:#57534e; }
    .tpl-minimal .r-skill-tag::after { content:' / '; color:#d4cfc8; }
    .tpl-minimal .r-skill-tag:last-child::after { content:''; }

    /* ── Template: Warm ── */
    .tpl-warm { font-family:'DM Sans',sans-serif; padding:40px 48px; background:#fff; }
    .tpl-warm .r-name { font-size:28px; font-weight:800; color:#92400e; letter-spacing:-.5px; }
    .tpl-warm .r-title { font-size:13px; color:#d97706; font-weight:600; margin-top:3px; }
    .tpl-warm .r-contact { display:flex; gap:16px; flex-wrap:wrap; margin-top:8px; font-size:12px; color:#78716c; }
    .tpl-warm .r-divider { height:3px; background:linear-gradient(90deg,#f59e0b,#fbbf24,transparent); margin:16px 0; border-radius:2px; }
    .tpl-warm .r-section-title { font-size:11px; font-weight:800; letter-spacing:1.2px; text-transform:uppercase; color:#d97706; margin-bottom:10px; padding-left:8px; border-left:3px solid #f59e0b; }
    .tpl-warm .r-exp-company { font-size:14px; font-weight:700; color:#1c1917; }
    .tpl-warm .r-exp-title { font-size:13px; color:#78716c; }
    .tpl-warm .r-exp-period { font-size:11px; color:#a8a29e; }
    .tpl-warm .r-bullet { font-size:12.5px; color:#44403c; line-height:1.75; padding-left:14px; position:relative; margin-bottom:4px; }
    .tpl-warm .r-bullet::before { content:'◆'; position:absolute; left:0; color:#f59e0b; font-size:7px; top:4px; }
    .tpl-warm .r-skill-tag { display:inline-block; background:#fffbeb; border:1px solid #fde68a; color:#92400e; font-size:11px; font-weight:600; padding:3px 10px; border-radius:5px; margin:3px; }

    /* ── Template: Bold ── */
    .tpl-bold { font-family:'DM Sans',sans-serif; padding:0; background:#fff; }
    .tpl-bold .r-header-block { background:linear-gradient(135deg,#4c1d95,#7c3aed); padding:36px 48px 28px; color:#fff; }
    .tpl-bold .r-name { font-size:30px; font-weight:900; color:#fff; letter-spacing:-.5px; }
    .tpl-bold .r-title { font-size:13px; color:#ddd6fe; font-weight:500; margin-top:4px; }
    .tpl-bold .r-contact { display:flex; gap:16px; flex-wrap:wrap; margin-top:10px; font-size:12px; color:#c4b5fd; }
    .tpl-bold .r-body-block { padding:32px 48px; }
    .tpl-bold .r-divider { display:none; }
    .tpl-bold .r-section-title { font-size:11px; font-weight:800; letter-spacing:1.5px; text-transform:uppercase; color:#7c3aed; margin-bottom:10px; margin-top:24px; }
    .tpl-bold .r-exp-company { font-size:14px; font-weight:700; color:#1c1917; }
    .tpl-bold .r-exp-title { font-size:13px; color:#57534e; }
    .tpl-bold .r-exp-period { font-size:11px; color:#a8a29e; }
    .tpl-bold .r-bullet { font-size:12.5px; color:#44403c; line-height:1.75; padding-left:14px; position:relative; margin-bottom:4px; }
    .tpl-bold .r-bullet::before { content:'▸'; position:absolute; left:0; color:#7c3aed; }
    .tpl-bold .r-skill-tag { display:inline-block; background:#f5f3ff; border:1px solid #ddd6fe; color:#6d28d9; font-size:11px; font-weight:600; padding:3px 10px; border-radius:5px; margin:3px; }

    /* ── Input/Textarea ── */
    .field {
      width:100%; background:var(--sand); border:1.5px solid var(--border); border-radius:10px;
      padding:10px 14px; font-family:'DM Sans',sans-serif; font-size:13px; color:var(--ink);
      outline:none; transition:border-color .15s; resize:vertical;
    }
    .field:focus { border-color:var(--emerald); background:#fff; }
    .field::placeholder { color:var(--ink3); }

    /* ── Editable section ── */
    .edit-bullet {
      display:flex; align-items:flex-start; gap:8px; margin-bottom:6px;
    }
    .edit-bullet textarea {
      flex:1; background:var(--sand); border:1.5px solid transparent; border-radius:8px;
      padding:7px 10px; font-size:12.5px; color:var(--ink2); font-family:'DM Sans',sans-serif;
      resize:none; outline:none; line-height:1.7; transition:border-color .15s;
    }
    .edit-bullet textarea:focus { border-color:var(--emerald); background:#fff; }

    /* ── Toast ── */
    .toast {
      position:fixed; bottom:24px; left:50%; transform:translateX(-50%);
      background:var(--coal); color:#fff; padding:10px 20px; border-radius:10px;
      font-size:13px; font-weight:600; z-index:999; pointer-events:none;
      animation: fadeUp .3s ease;
    }

    /* ── Keyword highlight ── */
    .kw-new { background:#d1fae5; color:#065f46; border-radius:3px; padding:1px 3px; font-weight:600; }

    /* ── Compare view ── */
    .compare-col { flex:1; min-width:0; }
    .compare-label { font-size:10px; font-weight:800; letter-spacing:.8px; text-transform:uppercase; padding:6px 12px; border-radius:6px; margin-bottom:8px; display:inline-block; }

    /* ── Template preview card ── */
    .tpl-card {
      border:2px solid var(--border); border-radius:12px; overflow:hidden;
      cursor:pointer; transition:all .2s;
    }
    .tpl-card:hover { border-color:var(--emerald); transform:translateY(-2px); box-shadow:0 8px 24px rgba(0,0,0,.1); }
    .tpl-card.on { border-color:var(--emerald); box-shadow:0 0 0 3px rgba(5,150,105,.2); }

    /* ── Print styles ── */
    @media print {
      .app-shell, .sidebar, .main-area > *:not(.print-area) { display:none !important; }
      .print-area { display:block !important; }
      .resume-preview { box-shadow:none; }
    }
    .print-area { display:none; }

    /* ── Misc ── */
    .divider { height:1px; background:var(--border); margin:12px 0; }
    .mono { font-family:'JetBrains Mono',monospace; }
    .fraunces { font-family:'Fraunces',serif; }
    .lbl { font-size:10px; font-weight:700; color:var(--ink3); letter-spacing:.7px; text-transform:uppercase; margin-bottom:5px; }
    .section-gap { margin-bottom:18px; }
  `}</style>
);

/* AI CORE */


async function parseResumeAI(text) {
  const raw = await callAI([{ role: "user", content:
    `从以下简历文本中提取结构化信息，输出纯JSON（不含markdown）：\n\n${text}\n\n格式：
{
  "name":"姓名","title":"职位头衔","email":"邮箱","phone":"电话","location":"地点","linkedin":"",
  "summary":"职业概要（如有）",
  "education":[{"school":"学校","degree":"学位","field":"专业","period":"时间","gpa":""}],
  "experience":[{"company":"公司","title":"职位","period":"时间","location":"","bullets":["职责描述"]}],
  "projects":[{"name":"项目名","tech":"技术栈","period":"","bullets":["项目描述"]}],
  "skills":{"technical":["技能"],"soft":["软技能"],"languages":["语言"]}
}` }], "你是简历解析专家，严格输出JSON，不含任何说明。", 2000, "qwen");
  return safeJSON(raw);
}

async function optimizeBullets(bullets, mode, context = "") {
  const modeDesc = {
    polish: "润色语言：提升专业性、准确性和流畅度，保持原意",
    achievement: "强化成果：为每条职责添加量化结果（数字、百分比、规模），如无数字可合理推断",
    star: "STAR法则重写：Situation情境 → Task任务 → Action行动 → Result结果，每条完整体现",
  };
  const raw = await callAI([{ role:"user", content:
    `工作经历背景：${context}\n\n原始职责描述：\n${bullets.map((b,i)=>`${i+1}. ${b}`).join("\n")}\n\n优化模式：${modeDesc[mode]}\n\n请返回纯JSON数组（不含markdown），格式：{"bullets":["优化后的职责1","优化后的职责2"]}` }],
    "你是顶级简历优化专家，擅长撰写高影响力的职责描述。输出纯JSON。", 2000, "qwen");
  return safeJSON(raw).bullets;
}

async function jobMatchOptimize(resume, targetJob) {
  const raw = await callAI([{ role:"user", content:
    `目标岗位：${targetJob}\n\n当前简历数据：${JSON.stringify(resume, null, 2)}\n\n
请针对该岗位优化简历，返回纯JSON（不含markdown），包含：
{
  "summary": "针对该岗位优化的职业概要",
  "keywords": ["该岗位最重要的技能关键词（10-15个）"],
  "skills": {"technical":[],"soft":[],"languages":[]},
  "experience": [{"company":"","title":"","period":"","location":"","bullets":["优化后的职责（突出与岗位相关的经验）"]}],
  "projects": [{"name":"","tech":"","period":"","bullets":["优化后的项目描述"]}],
  "tips": ["优化建议1","优化建议2","优化建议3"]
}` }],
    "你是顶级求职顾问，精通针对特定岗位优化简历。输出纯JSON。", 3000, "qwen");
  return safeJSON(raw);
}

async function suggestLayout(resume) {
  const raw = await callAI([{ role:"user", content:
    `分析以下简历内容，给出排版优化建议，返回纯JSON：\n${JSON.stringify(resume)}\n\n格式：
{"section_order":["建议的版块顺序，如experience/education/projects/skills"],"tips":["排版建议1","建议2","建议3"],"score":85,"score_reasons":["理由"]}` }],
    "你是简历排版专家。输出纯JSON。", 1000, "qwen");
  return safeJSON(raw);
}

/* FILE PARSING (终极兼容版：支持 PDF, DOCX, TXT) */
async function extractTextFromFile(file) {
  const ext = file.name.split(".").pop().toLowerCase();

  if (ext === "pdf") {
    // Use pdfjs-dist to extract text client-side - no Anthropic API needed
    try {
      const pdfjsLib = await import("pdfjs-dist");
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
      const ab = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({
        data: ab,
        cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/cmaps/`,
        cMapPacked: true,
      }).promise;
      let fullText = "";
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const tc = await page.getTextContent();
        // Group items by vertical position to preserve line breaks
        const lineMap = {};
        tc.items.forEach(item => {
          const y = Math.round(item.transform[5]);
          if (!lineMap[y]) lineMap[y] = [];
          lineMap[y].push(item.str);
        });
       const sortedY = Object.keys(lineMap).map(Number).sort((a, b) => b - a);
        fullText += sortedY.map(y => lineMap[y].join(" ")).join("\n") + "\n\n";
      }
      if (!fullText.trim()) throw new Error("PDF 文字提取为空");
      return fullText.trim();
    } catch (e) {
      throw new Error("PDF 解析失败：" + e.message + "。建议将简历另存为 DOCX 格式后重试。");
    }
  }

  if (ext === "docx" || ext === "doc") {
    const ab = await file.arrayBuffer();
    const result = await mammoth.extractRawText({ arrayBuffer: ab });
    return result.value;
  }

  if (ext === "txt") return new TextDecoder().decode(await file.arrayBuffer());
  throw new Error("不支持的文件格式，请上传 PDF、DOCX 或 TXT");
}
/* CONSTANTS */
const OPTIMIZE_MODES = [
  { id:"polish",      icon:"✨", label:"语言润色",   desc:"提升专业性与流畅度" },
  { id:"achievement", icon:"📊", label:"强化成果",   desc:"添加量化数字与指标" },
  { id:"star",        icon:"⭐", label:"STAR重写",   desc:"情境→任务→行动→结果" },
];

const TEMPLATES = [
  { id:"modern",  label:"现代绿",  desc:"简洁有力，适合科技/互联网", color:"#059669" },
  { id:"classic", label:"经典蓝",  desc:"沉稳大方，适合金融/咨询",   color:"#1d4ed8" },
  { id:"minimal", label:"极简黑白", desc:"干净优雅，适合设计/创意",   color:"#1c1917" },
  { id:"warm",    label:"暖色商务", desc:"亲和力强，适合销售/运营",   color:"#d97706" },
  { id:"bold",    label:"深色科技", desc:"视觉突出，适合产品/研发",   color:"#7c3aed" },
];

const SB_STEPS = [
  { id:"upload",  label:"上传简历",   icon:"📄" },
  { id:"parse",   label:"AI解析",     icon:"🔍" },
  { id:"editor",  label:"编辑优化",   icon:"✏️" },
  { id:"export",  label:"导出下载",   icon:"⬇️" },
];

/* RESUME RENDERER */
function ResumeRenderer({ resume: r, template }) {
  const cls = `tpl-${template}`;
  const section = (title, children) => (
    <div style={{ marginBottom: 20 }}>
      <div className="r-section-title">{title}</div>
      {children}
    </div>
  );

  return (
    <div className={`resume-preview ${cls}`} id="resume-print-area">
      {/* Header */}
      <div className="r-name">{r.name || "姓名"}</div>
      {r.title && <div className="r-title">{r.title}</div>}
      <div className="r-contact">
        {r.email && <span>✉ {r.email}</span>}
        {r.phone && <span>📱 {r.phone}</span>}
        {r.location && <span>📍 {r.location}</span>}
        {r.linkedin && <span>🔗 {r.linkedin}</span>}
      </div>
      <div className="r-divider" />

      {/* Summary */}
      {r.summary && section("职业概要", <p style={{ fontSize:12.5, color:"#57534e", lineHeight:1.75 }}>{r.summary}</p>)}

      {/* Experience */}
      {r.experience?.length > 0 && section("工作经历", r.experience.map((exp, i) => (
        <div key={i} style={{ marginBottom: 16 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
            <div>
              <div className="r-exp-company">{exp.company}</div>
              <div className="r-exp-title">{exp.title}{exp.location ? ` · ${exp.location}` : ""}</div>
            </div>
            <div className="r-exp-period">{exp.period}</div>
          </div>
          <div style={{ marginTop: 6 }}>
            {(exp.bullets || []).map((b, bi) => <div key={bi} className="r-bullet">{b}</div>)}
          </div>
        </div>
      )))}

      {/* Education */}
      {r.education?.length > 0 && section("教育经历", r.education.map((edu, i) => (
        <div key={i} style={{ marginBottom: 10 }}>
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <div>
              <div className="r-exp-company">{edu.school}</div>
              <div className="r-exp-title">{edu.degree}{edu.field ? ` · ${edu.field}` : ""}{edu.gpa ? ` | GPA: ${edu.gpa}` : ""}</div>
            </div>
            <div className="r-exp-period">{edu.period}</div>
          </div>
        </div>
      )))}

      {/* Projects */}
      {r.projects?.length > 0 && section("项目经验", r.projects.map((proj, i) => (
        <div key={i} style={{ marginBottom: 14 }}>
          <div style={{ display:"flex", justifyContent:"space-between" }}>
            <div className="r-exp-company">{proj.name}</div>
            <div className="r-exp-period">{proj.period}</div>
          </div>
          {proj.tech && <div className="r-exp-title">技术栈：{proj.tech}</div>}
          <div style={{ marginTop: 5 }}>
            {(proj.bullets || []).map((b, bi) => <div key={bi} className="r-bullet">{b}</div>)}
          </div>
        </div>
      )))}

      {/* Skills */}
      {(r.skills?.technical?.length > 0 || r.skills?.soft?.length > 0) && section("技能", (
        <div>
          {r.skills?.technical?.length > 0 && (
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontSize:11, fontWeight:700, color:"#a8a29e", marginRight:8 }}>技术技能</span>
              {r.skills.technical.map((s, i) => <span key={i} className="r-skill-tag">{s}</span>)}
            </div>
          )}
          {r.skills?.soft?.length > 0 && (
            <div style={{ marginBottom: 8 }}>
              <span style={{ fontSize:11, fontWeight:700, color:"#a8a29e", marginRight:8 }}>软技能</span>
              {r.skills.soft.map((s, i) => <span key={i} className="r-skill-tag">{s}</span>)}
            </div>
          )}
          {r.skills?.languages?.length > 0 && (
            <div>
              <span style={{ fontSize:11, fontWeight:700, color:"#a8a29e", marginRight:8 }}>语言</span>
              {r.skills.languages.map((s, i) => <span key={i} className="r-skill-tag">{s}</span>)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/* STEP: UPLOAD */
function UploadStep({ onUpload, onDemo }) {
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef(null);

  const handleFile = (f) => { if (f) onUpload(f); };

  return (
    <div className="fu" style={{ maxWidth: 640, margin: "0 auto", padding: "60px 24px" }}>
      <div style={{ marginBottom: 40 }}>
        <div className="fraunces" style={{ fontSize: 32, fontWeight: 800, color: "var(--ink)", lineHeight: 1.2, marginBottom: 10 }}>
          上传你的简历
        </div>
        <p style={{ fontSize: 15, color: "var(--ink2)", lineHeight: 1.7 }}>
          支持 PDF、Word（DOCX）、TXT 格式，AI 将自动解析并智能优化
        </p>
      </div>

      <div
        className={`upload-zone ${dragOver ? "over" : ""}`}
        onDragOver={e => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={e => { e.preventDefault(); setDragOver(false); handleFile(e.dataTransfer.files[0]); }}
        onClick={() => fileRef.current?.click()}
      >
        <div style={{ fontSize: 52, marginBottom: 16 }}>📄</div>
        <div style={{ fontSize: 17, fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>拖拽简历文件到这里</div>
        <div style={{ fontSize: 13, color: "var(--ink3)", marginBottom: 24 }}>或点击选择文件 · PDF / DOCX / TXT</div>
        <button className="btn btn-primary" style={{ pointerEvents: "none" }}>选择文件</button>
       <input 
          ref={fileRef} 
          type="file" 
          accept=".pdf,.docx,.doc,.txt" 
          style={{ display: "none" }}
          onClick={(e) => { e.target.value = null; }}
          onChange={e => handleFile(e.target.files[0])} 
        />
      </div>

      <div style={{ marginTop: 24, display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
        <span style={{ fontSize: 12, color: "var(--ink3)" }}>或者</span>
        <div style={{ flex: 1, height: 1, background: "var(--border)" }} />
      </div>

      <div style={{ marginTop: 20 }}>
        <button className="btn btn-secondary" style={{ width: "100%", padding: "12px" }} onClick={onDemo}>
          🎯 使用演示简历快速体验
        </button>
      </div>

      <div style={{ marginTop: 28, display: "flex", gap: 12 }}>
        {[["🔒","数据安全","文件不会被储存，处理后即丢弃"],["⚡","极速解析","AI 30秒内完成全文解析"],["🎯","精准优化","支持3种优化模式 + 岗位匹配"]].map(([ico, t, d]) => (
          <div key={t} className="card" style={{ flex: 1, padding: "14px", textAlign: "center" }}>
            <div style={{ fontSize: 22, marginBottom: 6 }}>{ico}</div>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 3 }}>{t}</div>
            <div style={{ fontSize: 11, color: "var(--ink3)", lineHeight: 1.5 }}>{d}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* STEP: PARSING */
function ParseStep({ file, onParsed, onError }) {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("正在读取文件...");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        setStatus("📖 正在提取文本内容..."); setProgress(15);
        const text = await extractTextFromFile(file);
        setStatus("🧠 AI 正在解析简历结构..."); setProgress(45);
        await new Promise(r => setTimeout(r, 400));
        setStatus("✨ 识别教育/工作/技能模块..."); setProgress(70);
        const parsed = await parseResumeAI(text);
        setStatus("✅ 解析完成！"); setProgress(100);
        await new Promise(r => setTimeout(r, 500));
        onParsed(parsed, text);
      } catch (e) { onError(e.message); }
    })();
  }, []);

  return (
    <div className="fu" style={{ maxWidth: 480, margin: "0 auto", padding: "80px 24px", textAlign: "center" }}>
      <div style={{ fontSize: 56, marginBottom: 24 }}>🔍</div>
      <div className="fraunces" style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>AI 解析中</div>
      <p style={{ fontSize: 14, color: "var(--ink2)", marginBottom: 32 }}>{status}</p>

      <div className="prog-track" style={{ marginBottom: 8 }}>
        <div className="prog-fill" style={{ width: `${progress}%` }} />
      </div>
      <div style={{ fontSize: 12, color: "var(--ink3)", marginBottom: 40 }}>{progress}%</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {["解析个人信息","识别工作经历","提取教育背景","分析技能标签"].map((item, i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, opacity: progress > (i+1)*20 ? 1 : 0.3, transition:"opacity .3s" }}>
            <div style={{ width:18, height:18, borderRadius:"50%", background: progress > (i+1)*20 ? "var(--emerald)" : "var(--sand3)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:10, color:"#fff", flexShrink:0 }}>
              {progress > (i+1)*20 ? "✓" : "○"}
            </div>
            <span style={{ fontSize:13, color:"var(--ink2)" }}>{item}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

/* PANEL: OPTIMIZE */
function OptimizePanel({ resume, onUpdate, showToast }) {
  const [mode, setMode] = useState("achievement");
  const [selExp, setSelExp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCompare, setShowCompare] = useState(false);
  const [original, setOriginal] = useState(null);

  const doOptimize = async () => {
    if (selExp === null) { showToast("请先选择要优化的工作经历"); return; }
    setLoading(true);
    try {
      const exp = resume.experience[selExp];
      setOriginal([...exp.bullets]);
      const optimized = await optimizeBullets(exp.bullets, mode, `${exp.title} at ${exp.company}`);
      const updated = { ...resume, experience: resume.experience.map((e, i) => i === selExp ? { ...e, bullets: optimized } : e) };
      onUpdate(updated);
      setShowCompare(true);
      showToast("✨ 优化完成！");
    } catch(e) { showToast("❌ " + e.message); }
    setLoading(false);
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div className="lbl">优化模式</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {OPTIMIZE_MODES.map(m => (
            <div key={m.id} className={`mode-chip ${mode === m.id ? "on" : ""}`}
              onClick={() => setMode(m.id)}
              style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 14px", textAlign:"left" }}>
              <span style={{ fontSize:18 }}>{m.icon}</span>
              <div>
                <div style={{ fontSize:13, fontWeight:700 }}>{m.label}</div>
                <div style={{ fontSize:11, opacity:.75 }}>{m.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: 16 }}>
        <div className="lbl">选择工作经历</div>
        {(resume.experience || []).length === 0
          ? <div style={{ fontSize:12, color:"var(--ink3)", padding:"10px 0" }}>暂无工作经历</div>
          : (resume.experience || []).map((exp, i) => (
            <div key={i} onClick={() => setSelExp(i)} style={{
              padding:"10px 12px", borderRadius:9, border:"1.5px solid",
              borderColor: selExp === i ? "var(--emerald)" : "var(--border)",
              background: selExp === i ? "var(--em3)" : "var(--white)",
              cursor:"pointer", marginBottom:6, transition:"all .14s",
            }}>
              <div style={{ fontSize:13, fontWeight:700 }}>{exp.company}</div>
              <div style={{ fontSize:11, color:"var(--ink3)" }}>{exp.title} · {exp.period}</div>
            </div>
          ))
        }
      </div>

      <button className="btn btn-primary" style={{ width:"100%", marginBottom:10 }}
        onClick={doOptimize} disabled={loading || selExp === null}>
        {loading ? <><span className="spin-a">⟳</span> 优化中...</> : "🚀 开始优化"}
      </button>

      {showCompare && original && selExp !== null && (
        <div style={{ marginTop:12 }}>
          <div style={{ fontSize:12, fontWeight:700, color:"var(--ink3)", marginBottom:8 }}>优化前后对比</div>
          <div style={{ display:"flex", gap:8 }}>
            <div className="compare-col">
              <div className="compare-label" style={{ background:"var(--rose3)", color:"var(--rose)", fontSize:10 }}>优化前</div>
              {original.map((b,i)=><div key={i} style={{ fontSize:11, color:"var(--ink3)", marginBottom:5, lineHeight:1.6, padding:"5px 8px", background:"var(--rose3)", borderRadius:6 }}>{b}</div>)}
            </div>
            <div className="compare-col">
              <div className="compare-label" style={{ background:"var(--em3)", color:"var(--emerald)", fontSize:10 }}>优化后</div>
              {(resume.experience[selExp]?.bullets||[]).map((b,i)=><div key={i} style={{ fontSize:11, color:"var(--ink)", marginBottom:5, lineHeight:1.6, padding:"5px 8px", background:"var(--em3)", borderRadius:6 }}>{b}</div>)}
            </div>
          </div>
          <button className="btn btn-ghost btn-sm" style={{ marginTop:8, width:"100%" }} onClick={() => setShowCompare(false)}>收起对比</button>
        </div>
      )}
    </div>
  );
}

/* PANEL: JOB MATCH */
function JobMatchPanel({ resume, onUpdate, showToast }) {
  const [job, setJob] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [applied, setApplied] = useState(false);

  const doMatch = async () => {
    if (!job.trim()) { showToast("请输入目标岗位名称"); return; }
    setLoading(true); setResult(null); setApplied(false);
    try {
      const r = await jobMatchOptimize(resume, job);
      setResult(r);
      showToast("🎯 岗位匹配优化完成！");
    } catch(e) { showToast("❌ " + e.message); }
    setLoading(false);
  };

  const applyOptimize = () => {
    if (!result) return;
    const updated = {
      ...resume,
      summary: result.summary || resume.summary,
      skills: result.skills || resume.skills,
      experience: result.experience?.length ? result.experience : resume.experience,
      projects: result.projects?.length ? result.projects : resume.projects,
    };
    onUpdate(updated);
    setApplied(true);
    showToast("✅ 已应用岗位优化结果");
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div className="lbl">目标岗位</div>
        <input className="field" placeholder="例：前端工程师 / 产品经理 / 数据分析师..."
          value={job} onChange={e => setJob(e.target.value)}
          onKeyDown={e => e.key === "Enter" && doMatch()}
          style={{ lineHeight:1 }} />
        <div style={{ fontSize:11, color:"var(--ink3)", marginTop:5 }}>AI 将根据该岗位要求，优化关键词、技能描述和工作经历</div>
      </div>

      <button className="btn btn-amber" style={{ width:"100%", marginBottom:16 }}
        onClick={doMatch} disabled={loading || !job.trim()}>
        {loading ? <><span className="spin-a">⟳</span> 分析中...</> : "🎯 一键岗位匹配"}
      </button>

      {result && (
        <div className="si">
          {result.keywords?.length > 0 && (
            <div style={{ marginBottom:14 }}>
              <div className="lbl">推荐关键词</div>
              <div style={{ display:"flex", flexWrap:"wrap", gap:5 }}>
                {result.keywords.map((kw,i) => <span key={i} className="tag tag-em">{kw}</span>)}
              </div>
            </div>
          )}

          {result.tips?.length > 0 && (
            <div className="card-sky" style={{ padding:"12px 14px", marginBottom:14 }}>
              <div className="lbl" style={{ color:"var(--sky)" }}>💡 优化建议</div>
              {result.tips.map((t,i) => (
                <div key={i} style={{ fontSize:12, color:"#0c4a6e", marginBottom:4, display:"flex", gap:6 }}>
                  <span style={{ color:"var(--sky)", fontWeight:700 }}>›</span>{t}
                </div>
              ))}
            </div>
          )}

          {result.summary && (
            <div style={{ marginBottom:14 }}>
              <div className="lbl">优化后的职业概要</div>
              <div style={{ fontSize:12, color:"var(--ink2)", background:"var(--sand2)", padding:"10px 12px", borderRadius:8, lineHeight:1.75 }}>
                {result.summary}
              </div>
            </div>
          )}

          {!applied ? (
            <button className="btn btn-primary" style={{ width:"100%" }} onClick={applyOptimize}>
              ✅ 应用所有优化
            </button>
          ) : (
            <div style={{ textAlign:"center", padding:"10px", fontSize:13, color:"var(--emerald)", fontWeight:700 }}>
              ✓ 已应用到简历
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* PANEL: LAYOUT */
function LayoutPanel({ resume, onUpdate, showToast }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const doAnalyze = async () => {
    setLoading(true);
    try {
      const r = await suggestLayout(resume);
      setResult(r);
    } catch(e) { showToast("❌ " + e.message); }
    setLoading(false);
  };

  return (
    <div>
      <p style={{ fontSize:13, color:"var(--ink2)", marginBottom:14, lineHeight:1.7 }}>
        AI 分析你的简历内容，给出版块排序和排版建议，提升视觉层次感。
      </p>

      <button className="btn btn-sky" style={{ width:"100%", marginBottom:14 }}
        onClick={doAnalyze} disabled={loading}>
        {loading ? <><span className="spin-a">⟳</span> 分析中...</> : "📐 分析排版结构"}
      </button>

      {result && (
        <div className="si">
          {result.score !== undefined && (
            <div style={{ display:"flex", alignItems:"center", gap:12, padding:"12px", background:"var(--sand2)", borderRadius:10, marginBottom:14 }}>
              <div style={{ width:52, height:52, borderRadius:"50%", border:`3px solid ${result.score>=80?"var(--emerald)":result.score>=60?"var(--amber)":"var(--rose)"}`, display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'JetBrains Mono',monospace", fontWeight:700, fontSize:16, color:result.score>=80?"var(--emerald)":result.score>=60?"var(--amber)":"var(--rose)", flexShrink:0 }}>
                {result.score}
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:700 }}>简历排版评分</div>
                <div style={{ fontSize:11, color:"var(--ink3)" }}>{result.score>=80?"优秀":result.score>=60?"良好":"需改进"}</div>
              </div>
            </div>
          )}

          {result.section_order?.length > 0 && (
            <div style={{ marginBottom:14 }}>
              <div className="lbl">建议版块顺序</div>
              {result.section_order.map((s,i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", background:"var(--sand2)", borderRadius:7, marginBottom:4 }}>
                  <span style={{ fontSize:11, fontFamily:"'JetBrains Mono',monospace", fontWeight:600, color:"var(--emerald)" }}>{String(i+1).padStart(2,"0")}</span>
                  <span style={{ fontSize:12, fontWeight:600 }}>{s}</span>
                </div>
              ))}
            </div>
          )}

          {result.tips?.length > 0 && (
            <div>
              <div className="lbl">排版建议</div>
              {result.tips.map((t,i) => (
                <div key={i} style={{ fontSize:12, color:"var(--ink2)", display:"flex", gap:7, marginBottom:6, lineHeight:1.6 }}>
                  <span style={{ color:"var(--amber)", fontWeight:700 }}>•</span>{t}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

/* PANEL: EDIT RESUME */
function EditPanel({ resume, onUpdate }) {
  const upd = (path, val) => {
    const r = JSON.parse(JSON.stringify(resume));
    const keys = path.split(".");
    let cur = r;
    for (let i = 0; i < keys.length - 1; i++) cur = cur[keys[i]];
    cur[keys[keys.length - 1]] = val;
    onUpdate(r);
  };

  const updBullet = (type, idx, bi, val) => {
    const r = JSON.parse(JSON.stringify(resume));
    r[type][idx].bullets[bi] = val;
    onUpdate(r);
  };
  const addBullet = (type, idx) => {
    const r = JSON.parse(JSON.stringify(resume));
    r[type][idx].bullets = [...(r[type][idx].bullets || []), ""];
    onUpdate(r);
  };
  const delBullet = (type, idx, bi) => {
    const r = JSON.parse(JSON.stringify(resume));
    r[type][idx].bullets.splice(bi, 1);
    onUpdate(r);
  };

  return (
    <div style={{ overflowY: "auto", maxHeight: "calc(100vh - 200px)", paddingRight: 4 }}>
      {/* Basic Info */}
      <div style={{ marginBottom: 16 }}>
        <div className="lbl">基本信息</div>
        {[["name","姓名","text"],["title","职位头衔","text"],["email","邮箱","text"],["phone","电话","text"],["location","地点","text"]].map(([k, ph]) => (
          <input key={k} className="field" placeholder={ph} value={resume[k]||""} onChange={e=>upd(k, e.target.value)} style={{ marginBottom:6, lineHeight:1 }} />
        ))}
        <textarea className="field" placeholder="职业概要" rows={3} value={resume.summary||""} onChange={e=>upd("summary", e.target.value)} />
      </div>

      <div className="divider"/>

      {/* Experience */}
      <div style={{ marginBottom: 16 }}>
        <div className="lbl">工作经历</div>
        {(resume.experience || []).map((exp, i) => (
          <div key={i} style={{ background:"var(--sand2)", borderRadius:10, padding:"12px", marginBottom:10 }}>
            <div style={{ display:"flex", gap:6, marginBottom:6 }}>
              <input className="field" placeholder="公司" value={exp.company||""} onChange={e=>upd(`experience.${i}.company`, e.target.value)} />
              <input className="field" placeholder="职位" value={exp.title||""} onChange={e=>upd(`experience.${i}.title`, e.target.value)} />
            </div>
            <input className="field" placeholder="时间段" value={exp.period||""} onChange={e=>upd(`experience.${i}.period`, e.target.value)} style={{ marginBottom:8, lineHeight:1 }} />
            <div className="lbl" style={{ marginBottom:4 }}>职责描述</div>
            {(exp.bullets||[]).map((b, bi) => (
              <div key={bi} className="edit-bullet">
                <textarea rows={2} value={b} onChange={e=>updBullet("experience", i, bi, e.target.value)} />
                <button className="btn btn-icon btn-sm" onClick={()=>delBullet("experience",i,bi)} style={{ fontSize:12 }}>✕</button>
              </div>
            ))}
            <button className="btn btn-ghost btn-sm" onClick={()=>addBullet("experience",i)}>+ 添加描述</button>
          </div>
        ))}
      </div>

      <div className="divider"/>

      {/* Skills */}
      <div>
        <div className="lbl">技能（逗号分隔）</div>
        {[["技术技能","skills.technical"],["软技能","skills.soft"],["语言","skills.languages"]].map(([ph, path]) => (
          <input key={path} className="field" placeholder={ph} style={{ marginBottom:6, lineHeight:1 }}
            value={(path.split(".").reduce((o,k)=>o?.[k]||"",resume) || []).join(", ")}
            onChange={e => {
              const arr = e.target.value.split(",").map(s=>s.trim()).filter(Boolean);
              upd(path, arr);
            }} />
        ))}
      </div>
    </div>
  );
}

/* STEP: EDITOR  (main layout) */
function EditorStep({ resume, rawText, onUpdate, onExport, template, onTemplateChange }) {
  const [panel, setPanel] = useState("optimize");
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 2500); };

  const PANELS = [
    { id:"edit",      label:"✏️ 编辑" },
    { id:"optimize",  label:"✨ 优化" },
    { id:"jobmatch",  label:"🎯 岗位" },
    { id:"layout",    label:"📐 排版" },
    { id:"template",  label:"🎨 模板" },
  ];

  return (
    <div style={{ display:"flex", height:"100vh", overflow:"hidden" }}>

      {/* ── Left: Resume Preview ── */}
      <div style={{ flex:1, overflow:"auto", padding:"24px", background:"#e8e5e0", minWidth:0 }}>
        <div style={{ maxWidth:794, margin:"0 auto" }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
            <div style={{ fontSize:12, color:"var(--coal3)", fontWeight:600 }}>简历预览</div>
            <div style={{ display:"flex", gap:8 }}>
              <span className="tag tag-em">{TEMPLATES.find(t=>t.id===template)?.label}</span>
              <div style={{display:"flex",gap:6}}>
                <button className="btn btn-primary btn-sm" onClick={()=>onExport("pdf")} title="另存为PDF">📄 导出 PDF</button>
                <button className="btn btn-sm" onClick={()=>onExport("docx")} title="下载Word文档" style={{background:"rgba(29,78,216,.12)",color:"#1d4ed8",border:"1px solid rgba(29,78,216,.3)"}}>📝 导出 Word</button>
              </div>
            </div>
          </div>
          <ResumeRenderer resume={resume} template={template} />
        </div>
      </div>

      {/* ── Right: Control Panel ── */}
      <div style={{ width:320, flexShrink:0, background:"var(--white)", borderLeft:"1px solid var(--border)", display:"flex", flexDirection:"column", overflow:"hidden" }}>
        {/* Panel tabs */}
        <div style={{ borderBottom:"1px solid var(--border)", display:"flex", overflowX:"auto", flexShrink:0 }}>
          {PANELS.map(p => (
            <button key={p.id} className={`panel-tab ${panel===p.id?"on":""}`} onClick={()=>setPanel(p.id)}>
              {p.label}
            </button>
          ))}
        </div>

        {/* Panel content */}
        <div style={{ flex:1, overflow:"auto", padding:"16px" }}>
          {panel === "edit"     && <EditPanel      resume={resume} onUpdate={onUpdate} />}
          {panel === "optimize" && <OptimizePanel  resume={resume} onUpdate={onUpdate} showToast={showToast} />}
          {panel === "jobmatch" && <JobMatchPanel  resume={resume} onUpdate={onUpdate} showToast={showToast} />}
          {panel === "layout"   && <LayoutPanel    resume={resume} onUpdate={onUpdate} showToast={showToast} />}
          {panel === "template" && (
            <div>
              <div className="lbl" style={{ marginBottom:12 }}>选择简历模板</div>
              {TEMPLATES.map(t => (
                <div key={t.id} className={`tpl-card ${template===t.id?"on":""}`} onClick={()=>onTemplateChange(t.id)} style={{ marginBottom:10, padding:"12px 14px" }}>
                  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                    <div>
                      <div style={{ fontSize:13, fontWeight:700 }}>{t.label}</div>
                      <div style={{ fontSize:11, color:"var(--ink3)" }}>{t.desc}</div>
                    </div>
                    {template===t.id && <span style={{ color:"var(--emerald)", fontWeight:700, fontSize:16 }}>✓</span>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

/* DEMO RESUME DATA */
const DEMO_RESUME = {
  name: "张小明", title: "前端工程师", email: "zhang@example.com",
  phone: "138-0000-0001", location: "北京市", linkedin: "",
  summary: "三年前端开发经验，熟悉React和Vue生态，有良好的工程化实践经验。",
  education: [{ school:"北京大学", degree:"学士", field:"计算机科学", period:"2018–2022", gpa:"3.7" }],
  experience: [
    { company:"字节跳动", title:"前端开发工程师", period:"2022.07–至今", location:"北京",
      bullets:["负责开发内部工具平台，用户数约500人","参与了重构项目，改善了代码结构","修复了很多bug，保证了系统稳定","和后端同学配合完成了多个功能迭代"] },
    { company:"美团", title:"前端实习生", period:"2022.01–2022.06", location:"北京",
      bullets:["协助开发外卖商家端管理系统","编写了一些组件","学习了前端工程化相关知识"] },
  ],
  projects: [
    { name:"低代码平台", tech:"React / TypeScript / Ant Design", period:"2023.03–2023.09",
      bullets:["开发了低代码编辑器，支持拖拽组件","做了组件库，有很多组件","上线后部分团队在用"] },
  ],
  skills: { technical:["React","Vue","TypeScript","Node.js","Webpack","Git"], soft:["团队协作","沟通能力"], languages:["中文（母语）","英文（CET-6）"] },
};

/* MAIN APP */
export default function ResumeOptimizer() {
  const [step,        setStep]        = useState("upload");
  const [file,        setFile]        = useState(null);
  const [rawText,     setRawText]     = useState("");
  const [resume,      setResume]      = useState(null);
  const [template,    setTemplate]    = useState("modern");
  const [errMsg,      setErrMsg]      = useState("");
  const [unlocked,    setUnlocked]    = useState(resumeIsUnlocked);
  const [showPaywall, setShowPaywall] = useState(false);
  const printRef = useRef(null);

  const guard = (fn) => (...a) => { if (!unlocked) { setShowPaywall(true); return; } fn(...a); };
  const handleUpload = guard((f) => { setFile(f); setStep("parse"); });
  const handleDemo   = guard(() => { setResume(DEMO_RESUME); setStep("editor"); });

  const handleParsed = (parsed, text) => {
    setResume(parsed);
    setRawText(text);
    setStep("editor");
    saveToHistory(parsed);
  };

  const handleError = (msg) => { setErrMsg(msg); setStep("upload"); };

  // ── PDF 导出：打开干净打印页面，用户选"另存为PDF" ──
  const handleExport = (type = "pdf") => {
    if (type === "docx") { handleExportDocx(); return; }
    const printContent = document.getElementById("resume-print-area");
    if (!printContent) return;
    const allStyles = Array.from(document.styleSheets).reduce((acc, ss) => {
      try { return acc + Array.from(ss.cssRules).map(r=>r.cssText).join("\n"); } catch { return acc; }
    }, "");
    const html = printContent.outerHTML;
    const w = window.open("", "_blank");
    if (!w) { alert("请允许弹出窗口后重试"); return; }
    const name = resume?.name || "简历";
    w.document.write(`<!DOCTYPE html><html><head>
      <meta charset="UTF-8"><title>${name} - 简历</title>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Lora:ital,wght@0,400;0,600;1,400&display=swap" rel="stylesheet">
      <style>
        *{box-sizing:border-box;margin:0;padding:0;}
        html,body{background:#fff;width:210mm;}
        ${allStyles}
        @page{size:A4;margin:0;}
        @media print{
          html,body{width:210mm;background:#fff;}
          .resume-preview{width:100%!important;box-shadow:none!important;border:none!important;}
          body{-webkit-print-color-adjust:exact;print-color-adjust:exact;}
        }
        .print-tip{position:fixed;top:0;left:0;right:0;background:#1d4ed8;color:#fff;text-align:center;
          padding:10px;font-family:sans-serif;font-size:13px;z-index:9999;}
        @media print{.print-tip{display:none!important;}}
      </style>
      </head><body>
      <div class="print-tip">💡 在弹出的打印对话框中，选择打印机为「<b>另存为PDF / Save as PDF</b>」即可下载</div>
      ${html}
      <script>
        setTimeout(()=>{
          document.querySelector('.print-tip')&&(document.querySelector('.print-tip').style.display='none');
          window.print();
        },1200);
      <\/script>
      </body></html>`);
    w.document.close();
  };

  // ── DOCX 导出：生成 Word 可打开的 HTML 格式文档 ──
  const handleExportDocx = () => {
    if (!resume) return;
    const r = resume;
    const rows = (arr,fn) => (arr||[]).map(fn).join("");
    const esc = s => (s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    const html = `<!DOCTYPE html><html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
    <head><meta charset="UTF-8"><title>${esc(r.name)} - 简历</title>
    <style>
      body{font-family:"Microsoft YaHei",sans-serif;font-size:10.5pt;margin:2cm;color:#1c1917;}
      h1{font-size:18pt;margin-bottom:4pt;}
      h3{font-size:11pt;border-bottom:1px solid #ccc;padding-bottom:3pt;margin:14pt 0 6pt;color:#1d4ed8;}
      .contact{font-size:9.5pt;color:#666;margin-bottom:8pt;}
      .exp-header{display:flex;justify-content:space-between;margin-bottom:2pt;}
      .company{font-weight:bold;font-size:11pt;}
      .period{font-size:9pt;color:#888;}
      ul{margin:4pt 0 8pt 16pt;padding:0;}
      li{margin-bottom:3pt;font-size:10pt;}
      .skills{font-size:10pt;line-height:1.8;}
    </style></head><body>
    <h1>${esc(r.name)}</h1>
    ${r.title?`<div style="font-size:12pt;color:#059669;margin-bottom:4pt;">${esc(r.title)}</div>`:""}
    <div class="contact">${[r.email,r.phone,r.location,r.linkedin].filter(Boolean).map(esc).join(" · ")}</div>
    ${r.summary?`<h3>职业概要</h3><p>${esc(r.summary)}</p>`:""}
    ${(r.experience||[]).length?`<h3>工作经历</h3>${rows(r.experience,e=>`
      <div class="exp-header"><span class="company">${esc(e.company)} · ${esc(e.title)}</span><span class="period">${esc(e.period)}</span></div>
      <ul>${rows(e.bullets||[],b=>`<li>${esc(b)}</li>`)}</ul>`)}`:""} 
    ${(r.education||[]).length?`<h3>教育经历</h3>${rows(r.education,e=>`
      <div class="exp-header"><span class="company">${esc(e.school)}</span><span class="period">${esc(e.period)}</span></div>
      <div style="font-size:10pt;color:#555;">${esc(e.degree)} · ${esc(e.field)}${e.gpa?` · GPA ${esc(e.gpa)}`:""}</div>
      <div style="margin-bottom:8pt;"></div>`)}`:""} 
    ${(r.projects||[]).length?`<h3>项目经历</h3>${rows(r.projects,p=>`
      <div class="company">${esc(p.name)} <span style="font-size:9.5pt;color:#888;font-weight:normal;">${esc(p.tech)}</span></div>
      <ul>${rows(p.bullets||[],b=>`<li>${esc(b)}</li>`)}</ul>`)}`:""} 
    ${(r.skills?.technical||r.skills?.soft)?`<h3>技能</h3>
      ${r.skills?.technical?.length?`<div class="skills"><b>技术技能：</b>${r.skills.technical.map(esc).join(" · ")}</div>`:""}
      ${r.skills?.soft?.length?`<div class="skills"><b>软技能：</b>${r.skills.soft.map(esc).join(" · ")}</div>`:""}
      ${r.skills?.languages?.length?`<div class="skills"><b>语言：</b>${r.skills.languages.map(esc).join(" · ")}</div>`:""}`:""} 
    </body></html>`;
    const blob = new Blob([html], {type:"application/msword;charset=utf-8"});
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${r.name||"简历"}_优化版.doc`;
    document.body.appendChild(a); a.click();
    document.body.removeChild(a); URL.revokeObjectURL(url);
  };

  const stepIdx = SB_STEPS.findIndex(s => s.id === step);

  return (
    <>
      <Styles />
      {showPaywall && <ResumePaywall onUnlock={()=>{setUnlocked(true);setShowPaywall(false);}} onClose={()=>setShowPaywall(false)} />}
      <div className="app-shell">

        {/* ── SIDEBAR ── */}
        <aside className="sidebar">
          <div className="sb-logo">
            <div className="sb-logo-text">ResumeAI</div>
            <div className="sb-logo-sub">AI 简历优化系统</div>
          </div>
          <nav className="sb-steps">
            {SB_STEPS.map((s, i) => (
              <div key={s.id} className={`sb-step ${step===s.id?"active":""} ${i<stepIdx?"done":""} ${i>stepIdx?"locked":""}`}
                onClick={() => { if (i < stepIdx || (i === stepIdx + 1 && resume)) setStep(s.id); }}>
                <div className="sb-num">{i < stepIdx ? "✓" : String(i+1)}</div>
                <span>{s.icon} {s.label}</span>
              </div>
            ))}
          </nav>
          <div className="sb-bottom">
            <div className="sb-badge">Claude AI 驱动</div>
            {resume && (
              <div style={{ marginTop:10, fontSize:11, color:"rgba(255,255,255,.3)", textAlign:"center" }}>
                {resume.name || "未知姓名"}
              </div>
            )}
          </div>
        </aside>

        {/* ── MAIN AREA ── */}
        <div className="main-area" style={{ overflow: step === "editor" ? "hidden" : "auto" }}>

          {errMsg && (
            <div style={{ padding:"16px 24px", background:"var(--rose3)", borderBottom:"1px solid #fecdd3", fontSize:13, color:"var(--rose)", display:"flex", alignItems:"center", gap:10 }}>
              ⚠️ {errMsg}
              <button className="btn btn-ghost btn-sm" onClick={() => { setErrMsg(""); setStep("upload"); }}>重新上传</button>
            </div>
          )}

          {step === "upload" && <UploadStep onUpload={handleUpload} onDemo={handleDemo} />}
          {step === "parse"  && <ParseStep  file={file} onParsed={handleParsed} onError={handleError} />}
          {step === "editor" && resume && (
            <EditorStep
              resume={resume} rawText={rawText}
              onUpdate={setResume}
              onExport={handleExport}
              template={template}
              onTemplateChange={setTemplate}
            />
          )}

          {step !== "editor" && resume && step !== "parse" && step !== "upload" && (
            <div style={{ padding:"40px 24px", textAlign:"center" }}>
              <button className="btn btn-primary" onClick={() => setStep("editor")}>返回编辑器</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
